import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();
  const { primary, secondary } = theme.palette;
  const { shadows } = theme;
  const { md } = theme.breakpoints;

  const container = css`
    position: relative;
  `;

  const wrapper = css`
    z-index: 10;
    display: flex;
    height: auto;
    width: 100%;
    align-items: center;
  `;

  const slidesWrapper = css`
    width: 100%;
    display: flex;
    align-items: center;
  `;

  const fadeWrapper = css`
    position: absolute;
    pointer-events: none;
    z-index: 101;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      white 5%,
      transparent 15%,
      transparent 85%,
      white 95%
    );
  `;

  const arrow = css`
    position: absolute;
    z-index: 110;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background: ${primary.dark};
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 50px;
    cursor: pointer;
    transition: all 0.3s ease;

    & > svg {
      color: white;
    }
  `;

  return { container, wrapper, slidesWrapper, fadeWrapper, arrow };
};

export default useStyle;
